const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectorswish = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.grid__item',
};

document.addEventListener('DOMContentLoaded', () => {
  console.log('[Wishlist] Init ✅');
  initButtons();
  initGrid();
  observeWishlistButtons();
  updateWishlistCount();
});

document.addEventListener('shopify-wishlist:updated', () => {
  initButtons();
  initGrid();
  updateWishlistCount();
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=wish`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(res, 'text/html');
      const productCard = htmlDocument.documentElement.querySelector(selectorswish.productCard);
      return productCard ? productCard.outerHTML : '';
    })
    .catch((err) =>
      console.error(`[Wishlist] Failed to load handle: ${handle}`, err)
    );
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle;
    if (!productHandle) {
      return console.error('[Wishlist] Missing `data-product-handle`.');
    }

    // Prevent re-initialization
    if (button.dataset.wishlistInit === "true") return;
    button.dataset.wishlistInit = "true";

    // Initial state
    if (wishlistContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    } else {
      button.classList.remove(BUTTON_ACTIVE_CLASS);
    }

    // Toggle on click
    button.addEventListener('click', () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectorswish.grid);
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectorswish.button);
  console.log('[Wishlist] Found buttons:', buttons.length);

  if (buttons.length) setupButtons(buttons);

  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

// --- OBSERVER: Watch for new wishlist buttons being added ---
const observeWishlistButtons = () => {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if ([...mutation.addedNodes].some(node =>
        node.nodeType === 1 && node.querySelector?.(selectorswish.button)
      )) {
        initButtons();
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

// --- STORAGE HELPERS ---
const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist ? wishlist.split(LOCAL_STORAGE_DELIMITER) : [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) {
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);
  updateWishlistCount();

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);

  if (indexInWishlist === -1) {
    wishlist.push(handle);
  } else {
    wishlist.splice(indexInWishlist, 1);
  }

  return setWishlist(wishlist);
};

const wishlistContains = (handle) => getWishlist().includes(handle);

const resetWishlist = () => setWishlist([]);

// --- COUNTER ---
const updateWishlistCount = () => {
  const wishlist = getWishlist();

  document.querySelectorAll('[data-js-wishlist-count]').forEach(el => {
    el.setAttribute('data-js-wishlist-count', wishlist.length);
    el.textContent = wishlist.length;
  });

  const emptyText = document.querySelector('.wishlist-text');
  if (emptyText) {
    emptyText.style.display = wishlist.length === 0 ? 'block' : 'none';
  }
};
